<template>
  <v-menu
    v-model="displayMenu"
    offset-y
    class="auto-search-menu"
    :close-on-content-click="false"
    :nudge-width="menuWidth"
  >
    <template v-slot:activator="{ on }">
      <v-btn :color="menuColor" dark v-on="on">
        {{ menuText }}
      </v-btn>
    </template>
    <v-list>
      <div class="auto-search-menu-text">
        Choose a client
      </div>
      <div class="auto-search-menu-input">
        <input v-model="inputClient" type="text" placeholder="Enter Name">
      </div>
      <div class="auto-search-menu-names">
        <v-list-tile
          v-for="(client, index) in selectedMenuOptions"
          :key="index"
          @click="clientClicked(client)"
        >
          <v-list-tile-title>
            {{ client.name }}
            <span v-if="menuType !== 'load'">
              {{
                menuType === "save" &&
                  client.autosearch &&
                  client.autosearch.length
                  ? " - save update"
                  : ""
              }}
            </span>
          </v-list-tile-title>
        </v-list-tile>
      </div>
      <div style="height: 1rem" />
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    menuText: {
      type: String,
      required: true
    },
    menuColor: {
      type: String,
      required: true
    },
    menuOptions: {
      type: Array,
      required: true
    },
    menuType: {
      type: String,
      default: 'save'
    },
    menuWidth: {
      type: Number,
      default: 80
    }
  },

  data: () => ({
    displayMenu: false,
    inputClient: ''
  }),

  computed: {
    selectedMenuOptions() {
      return this.inputClient ? this.filterOptions() : this.menuOptions
    }
  },

  methods: {
    clientClicked(client) {
      this.$emit('save-load-search', {
        selectedClient: client,
        type: this.menuType
      })
      this.displayMenu = false
    },

    filterOptions() {
      let regex = new RegExp('^' + this.inputClient + '.*', 'i')
      return this.menuOptions.filter(option => option.name.match(regex))
    }
  }
}
</script>

<style lang="sass" scoped>
.auto-search-menu
  width: 200%
  &-text
    font-size: 1.2rem
    color: $hwayzDarkGray
    margin: 1rem
  &-input
    margin: 0.5rem 1rem
    input
      height: 3.5rem
      width: 100%
      line-height: 3.5rem
      padding: 0 1rem
      font-size: 1.4rem
      border: 0.1rem solid $hwayzLightGray
      border-radius: 0.5rem
  &-names
    max-height: 30rem
    overflow: auto
    span
      font-size: 1.2rem
      display: inline-block
      line-height: 1.6rem
      color: $hwayzSun
      &.load-option
        color: $hwayzShadow
  &-selected
    background: $hwayzLightGray
  &-btn
    width: 90%
    margin-top: 1rem
    font-size: 1.2rem
</style>
